import { render, staticRenderFns } from "./Volunteer.vue?vue&type=template&id=c2636a88&"
import script from "./Volunteer.vue?vue&type=script&lang=js&"
export * from "./Volunteer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports